import { ticketsPdfApi } from "../../api";

const TicketPdfService = {
  /**
   * 🎫 Previsualiza o descarga un ticket PDF.
   * GET /api/pdf/tickets/{id}/branch/{branchId}
   *
   * Devuelve tanto el blob como el nombre real del archivo (si viene en el header).
   */
  view: async (
    saleId: number,
    branchId: number
  ): Promise<{ blob: Blob; fileName: string | null }> => {
    const response = await ticketsPdfApi.fetchBlob(`/${saleId}/branch/${branchId}`);

    // 🧠 Si tu `fetchBlob` ya fue mejorado para extraer el filename desde el header,
    // este valor ya estará disponible como response.fileName
    return {
      blob: response.data,
      fileName: response.fileName || null,
    };
  },
};

export default TicketPdfService;
